"use strict";

const Axe = require(41);
const format = require(30);
const formatSpecifiers = require(125);
const isError = require(164);
const mergeOptions = require(180);
const parseErr = require(207);
const pkg = require(61);
const {
  isNull,
  isUndefined,
  isObject,
  isString,
  isFunction
} = require(60);
const message = require(54);
const middleware = require(54);
class Cabin {
  constructor(config) {
    var _this = this;
    this.config = mergeOptions({
      logger: console,
      meta: {},
      // <https://github.com/cabinjs/parse-request>
      parseRequest: {},
      // <https://github.com/cabinjs/parse-err>
      errorProps: [],
      // function that accepts (level, req, res) and returns a string
      // (this is consumed by the cabin middleware and not available in browsers)
      message,
      // expose a version for user agent
      version: pkg.version
    }, config);
    if (!isObject(this.config.logger)) throw new Error('Logger option must be a logger object such as `console` or an instance of Axe');
    if (!(this.config.logger instanceof Axe)) this.config.logger = new Axe({
      logger: this.config.logger
    });

    // parse arg helper
    this.parseArg = this.parseArg.bind(this);

    // bind helper functions for each log level
    for (const level of Object.keys(this.config.logger).filter(key => isFunction(this.config.logger[key]))) {
      this[level] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        // support format specifiers
        if (typeof args[0] === 'string' && formatSpecifiers.some(t => args[0].includes(t)) && args[1]) {
          args[0] = format(args[0], args[1]);
          delete args[1];
        } else if (args[1]) args[1] = _this.parseArg(args[1]);
        return _this.config.logger[level](...Array.prototype.slice.call(args));
      };
    }

    // aliases
    this.err = this.error;
    this.warning = this.warn;

    // we'd use `auto-bind` package but unfortunately it
    // doesn't have a compiled version without `const` etc
    this.setMeta = this.setMeta.bind(this);
    this.setUser = this.setUser.bind(this);
    if (isFunction(middleware)) this.middleware = middleware.bind(this);
  }
  parseArg() {
    let arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (isObject(arg)) {
      Object.assign(arg, this.config.meta);
      return arg;
    }
    if (isUndefined(arg) || isNull(arg)) arg = {};else if (isError(arg)) arg = {
      err: parseErr(arg, this.config.errorProps)
    };else if (Array.isArray(arg)) arg = {
      value: arg
    };else if (isString(arg)) arg = {
      value: arg
    };else if (typeof arg === 'number') arg = {
      value: arg
    };else if (isFunction(arg)) arg = {
      value: arg.toString()
    };else arg = {};
    Object.assign(arg, this.config.meta);
    return arg;
  }
  setMeta() {
    let meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.config.meta = meta;
  }
  setUser() {
    let user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.config.meta.user = user;
  }
}
module.exports = Cabin;